<template>
	<div class="theme-provider">
		<slot></slot>
	</div>
</template>

<script>
import { mapState } from 'pinia'
import { useMainStore } from '@/store/main'
import { useLocationStore } from '@/store/location'
export default {
	name: 'ThemeProvider',

	watch: {
		theme: {
			handler(theme) {
				document.body.setAttribute('data-theme', theme)
				useMainStore().setAppTheme(theme)
			},

			immediate: true,
		},
	},

	computed: {
		...mapState(useLocationStore, {
			appAreaConfig: 'getAppAreaConfig',
		}),

		theme() {
			return this.appAreaConfig.funnel.theme ?? 'light'
		},
	},
}
</script>
